import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  skeletonContainer: { width: '100%' },
  skeleton: { width: '100%', height: 60, marginBottom: 20 },
  skeletonRow: { width: '100%', height: 40 },
  root: {
    position: 'relative',
    width: '100%'
  },
  startIcon: {
    marginRight: -4
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: 6,
    [theme.breakpoints.down('sm')]: {
      margin: 0
    }
  }
}))

export default useStyles
